import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6d9570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color" }

import { computed } from 'vue'
  import { useColors } from 'vuestic-ui'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ColorDropdownItem',
  props: {
    colorName: null
  },
  setup(__props: any) {

  const { getColors } = useColors()
  
  const theme = computed(() => {
    return getColors()
  })

return (_ctx: any,_cache: any) => {
  const _component_va_color_indicator = _resolveComponent("va-color-indicator")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createVNode(_component_va_color_indicator, {
        color: _unref(theme)[__props.colorName]
      }, null, 8, ["color"])
    ]),
    _createElementVNode("td", null, _toDisplayString(__props.colorName), 1)
  ]))
}
}

})